import { DataSource, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutProspectToLocation extends Layout {
    labelRecordCount: Label;
    labelSelectedRecords: Label;
    panel1: Panel;
    sourceLocation: DataSource;
    sourcePreviewProspectToLocation: DataSource;
    sourceProspect: DataSource;
    tableProspectsCovert: Table;
}
